<template>
  <v-menu
    v-model="menu"
    transition="fade-transition"
    :close-on-content-click="false"
    max-width="490"
    nudge-width="490"
    class="support-shadow"
    offset-y
  >
    <template v-slot:activator="{ on }">
      <v-btn
        v-on="on"
        dark
        fab
        :x-small="$store.getters.mobile ? true : false"
        :small="!$store.getters.mobile ? true : false"
        color="primary"
        elevation="0"
        :title="$t('support')"
      >
        <v-icon v-if="menu == false" size="18">mdi-headset</v-icon>
        <v-icon v-else size="18">mdi-close</v-icon>
      </v-btn>
    </template>

    <v-card class="chat-card-container" elevation="10">
      <!-- Header -->
      <div class="chat-custom-header">
        <div class="d-flex align-center">
          <v-avatar size="40" class="mr-3 border-white-avatar">
            <img
              src="/assets/images/brand/primary-icon-logo.svg"
              alt="Logo Soporte"
            />
          </v-avatar>
          <div class="text-left">
            <div class="white--text font-weight-bold body-1">
              Soporte Técnico
            </div>
            <div class="white--text caption">
              <v-icon x-small color="green accent-2">mdi-circle</v-icon> En
              línea
            </div>
          </div>
        </div>
        <v-btn icon dark small @click="menu = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>

      <!-- STEP 1 -->
      <v-card-text v-if="step == 1" class="pa-6 text-center bg-light">
        <v-icon size="60" color="primary" class="mb-4"
          >mdi-shield-check-outline</v-icon
        >
        <h3 class="headline font-weight-bold mb-3" style="color: #333">
          ¿Necesitas ayuda?
        </h3>
        <p class="body-1 grey--text text--darken-2">
          Para conectar con un agente, es necesario generar tus
          <strong>credenciales de validación</strong>.
        </p>
        <v-btn
          @click="generateCode()"
          color="primary"
          block
          rounded
          large
          class="mt-4 text-none elevation-2 font-weight-bold"
        >
          Generar códigos de acceso
        </v-btn>
      </v-card-text>

      <!-- STEP 2 -->
      <v-card-text v-if="step == 2" class="pa-6 bg-light">
        <div class="alert-info-box mb-5 d-flex align-start">
          <v-icon color="primary" class="mr-2 mt-1"
            >mdi-information-outline</v-icon
          >
          <div>
            <div class="body-2 mb-1" style="line-height: 1.4">
              Inicie el chat con el botón inferior. Si no abre automáticamente,
              contacte a nuestra línea oficial:
            </div>
            <div class="subtitle-1 font-weight-black primary--text">
              +57 {{ numeroSoporte }}
            </div>
            <div class="body-2 grey--text text--darken-3 mt-1">
              y proporcione estos códigos:
            </div>
          </div>
        </div>

        <div class="custom-code-field mb-3">
          <span class="field-label">Código de Empresa</span>
          <div class="d-flex align-center justify-space-between">
            <span class="field-value">{{ codigoEmpresa }}</span>
            <v-btn icon small color="primary" @click="copyVal(codigoEmpresa)">
              <v-icon small>mdi-content-copy</v-icon>
            </v-btn>
          </div>
        </div>

        <div class="custom-code-field mb-5">
          <span class="field-label">Código de Verificación</span>
          <div class="d-flex align-center justify-space-between">
            <span class="field-value">{{ codigoVerificacion }}</span>
            <v-btn
              icon
              small
              color="primary"
              @click="copyVal(codigoVerificacion)"
            >
              <v-icon small>mdi-content-copy</v-icon>
            </v-btn>
          </div>
        </div>

        <v-btn
          @click="openWhatsapp()"
          color="#25D366"
          dark
          block
          rounded
          x-large
          class="text-none elevation-3 font-weight-bold"
        >
          <v-icon left size="28">mdi-whatsapp</v-icon>
          Iniciar conversación
        </v-btn>
      </v-card-text>

      <div
        class="py-3 grey--text text--darken-1 caption text-center bg-light d-flex align-center justify-center border-top"
      >
        <v-icon x-small color="grey darken-1" class="mr-1"
          >mdi-shield-check</v-icon
        >
        <span class="font-weight-medium">Seguridad garantizada</span>
      </div>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  data() {
    return {
      menu: false,
      codigoEmpresa: null,
      codigoVerificacion: null,
      numeroSoporte: "",
      user: null,
      step: 1,
    };
  },
  async mounted() {
    await this.$nextTick();
    await this.getNumberWhatsapp();
    await this.validateStatusCode();
    this.codigoEmpresa = this.$store.getters.company.identifier ?? "";
    this.codigoVerificacion =
      this.$store.getters.company.support_verification_code ?? null;
    if (this.codigoVerificacion) {
      this.step = 2;
    }
  },
  watch: {
    "$store.getters.user"(user) {
      this.user = user;
    },
    "$store.getters.company"(company) {
      this.codigoEmpresa = company.identifier ?? "";
      this.codigoVerificacion = company.support_verification_code ?? null;
      if (this.codigoVerificacion) {
        this.step = 2;
      }
    },
  },
  methods: {
    updateMenuPosition() {
      this.$nextTick(() => {
        if (this.$refs.menuComp) {
          // Este método interno de Vuetify recalcula la posición
          this.$refs.menuComp.updateDimensions();
        }
      });
    },
    openWhatsapp() {
      let codigo = this.codigoEmpresa;
      let verificacion = this.codigoVerificacion;
      let numero = this.numeroSoporte;
      return window.open(
        `https://wa.me/${numero}?text=Hola,%20solicito%20atenci%C3%B3n.%20Empresa:%20${codigo}.%20Validaci%C3%B3n:%20${verificacion}`,
        "_blank"
      );
    },
    async generateCode() {
      const res = await this.$http.get(
        "api/v1/generate-codes-validation",
        null,
        true,
        true
      );
      if (res.success) {
        this.codigoVerificacion = res.data?.token;
        this.step = 2;
        this.updateMenuPosition();
      }
    },
    async validateStatusCode() {
      const res = await this.$http.get(
        "api/v1/validate-codes-validation",
        null,
        true,
        true
      );
      if (res.success && !res.status) {
        this.codigoVerificacion = null;
        this.step = 1;
        this.updateMenuPosition();
      }
    },
    async getNumberWhatsapp() {
      const res = await this.$http.get(
        "api/v1/get-number-support-chat",
        null,
        true,
      );
      if (res.success) {
        this.numeroSoporte = res.data.number;
      }
    },
    copyVal(val) {
      navigator.clipboard
        .writeText(val)
        .then(() => {
          console.log("Texto copiado 👍");
        })
        .catch((err) => {
          console.error("Error al copiar:", err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.support-icon {
  position: fixed;
  border-radius: 30px 0px 0px 30px !important;
  right: 0;
  bottom: 3vw;
  width: 50px !important;
  height: 50px !important;
  z-index: 100;
  .v-icon {
    margin-left: 5px;
  }
}

.chat-menu-custom {
  border-radius: 16px !important;
  overflow: hidden;
}
.chat-card-container {
  border-radius: 16px !important;
  overflow: hidden;
}

.chat-custom-header {
  background: #24a9e1;
  padding: 18px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.border-white-avatar {
  border: 2px solid white;
  background: #ffffff !important;
  img {
    width: 90%;
  }
}
.bg-light {
  background-color: #fdfdfd;
}
.border-top {
  border-top: 1px solid #eee;
}

.custom-code-field {
  background: white;
  border: 1.5px solid #e0e0e0;
  border-radius: 12px;
  padding: 12px 16px;

  .field-label {
    display: block;
    font-size: 11px;
    text-transform: uppercase;
    color: #616161; /* Más oscuro para mejor lectura */
    font-weight: 800;
    margin-bottom: 4px;
  }

  .field-value {
    font-family: "Courier New", Courier, monospace;
    font-weight: bold;
    font-size: 1.2rem;
    color: #1a237e;
  }
}

.alert-info-box {
  background: #e3f2fd;
  border-left: 5px solid #2196f3;
  padding: 15px;
  border-radius: 8px;
  color: #0d47a1;
}
</style>